export const actionTypes = {
  REQUEST_START: 'TAPS.DETAIL_3NDFL_REFUND.REQUEST_START',
  REQUEST_SUCCESS: 'TAPS.DETAIL_3NDFL_REFUND.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'TAPS.DETAIL_3NDFL_REFUND.REQUEST_FAILURE',
  RESET_DATA: 'TAPS.DETAIL_3NDFL_REFUND.RESET_DATA',
};

export function startRequest(data) {
  return {
    type: actionTypes.REQUEST_START,
    payload: data,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}

export function resetData() {
  return {
    type: actionTypes.RESET_DATA,
  };
}
